import { render, staticRenderFns } from "./AppContainer.vue?vue&type=template&id=38c3f650&"
import script from "./AppContainer.vue?vue&type=script&lang=js&"
export * from "./AppContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports